export function groupArchivedFiles(archives = []) {
  const groups = new Map();

  archives.forEach((archive) => {
    const id = JSON.stringify([archive.documentClass, archive.idTipoDocumental, archive.documentReference, archive.pdf]);
    if (!groups.has(id)) {
      groups.set(id, { id, archive, number: archive.documentReference, language: [] });
    }

    const group = groups.get(id);
    if (!group.language.some(({ value }) => value === archive.languageId)) {
      group.language.push({ value: archive.languageId, label: archive.language });
    }
  });

  return Array.from(groups.values());
}

export function appendCertificateFiles(formData, files, type, includeArchives = false) {
  let uploadIndex = 0;
  const archives = [];

  files.forEach(({ file, archive, language, number }) => {
    if (archive) {
      language.forEach(({ value, label }) => {
        archives.push({ ...archive, languageId: value, language: label });
      });
    } else {
      formData.append(`${type}Files`, file);
      formData.append(`${type}Numbers`, number);
      language.forEach(({ value }, languageIndex) => {
        formData.append(`${type}FileLanguages[${uploadIndex}][${languageIndex}]`, value);
      });
      uploadIndex += 1;
    }
  });

  if (includeArchives) {
    const field = type === "certificate" ? "CertificateClonedUploads" : "ReportClonedUploads";
    formData.append(field, JSON.stringify(archives));
  }
}
